import { useQuery } from '@tanstack/react-query';

import { getShortPaymentDetails } from '../../api/payment-details.api';
import { PaymentDetailsEntry } from '../../types/payment-details';
import { PAYMENT_DETAILS_SHORT_QUERY_KEY, PAYMENT_DETAILS_STALE_TIME } from './use-payment-details';

/**
 * Short payment-details list for selectors (e.g. the Generate Invoices wallet popover).
 * No pagination — entry counts are small (soft-capped per org).
 */
export const usePaymentDetailsShort = ({ enabled = true }: { enabled?: boolean } = {}) => {
  return useQuery<PaymentDetailsEntry[]>({
    queryKey: PAYMENT_DETAILS_SHORT_QUERY_KEY,
    queryFn: getShortPaymentDetails,
    staleTime: PAYMENT_DETAILS_STALE_TIME,
    enabled,
  });
};

/**
 * Returns the organization's default entry (at most one per org).
 */
export const getDefaultPaymentDetails = (
  entries: PaymentDetailsEntry[] | undefined
): PaymentDetailsEntry | undefined => entries?.find(entry => entry.isDefault);
